import config from "./renewal.config";
import moment from "moment";
import * as globalUtils from "../../../helpers/utils";
import { config as globalConfig } from "../../../config";
import reduxStore from "../../../redux/store";

export const isRenewal = (policyData, productCode) =>
  policyData.productCode === productCode;
export const driverUsageSet = (driverList) => {
  if (driverList.length) {
    driverList.forEach((item, i) => {
      const length = driverList.length;
      item["driverUsagePercentageCode"] = 100 / (length % 4);
      if (length === 3 && i === 0) {
        item["driverUsagePercentageCode"] = 50;
      } else if (length === 4) {
        item["driverUsagePercentageCode"] = 25;
      }
    });
    return [...driverList];
  }
};

export const getPriceSummary = (priceDetails) => {
  return priceDetails?.map((ele) => {
    return {
      title: ele?.priceName,
      price: ele?.priceValue,
      code: ele?.priceCode,
    };
  });
};

export const getInceptionDate = (date) => {
  return moment(date, "DD-MM-YYYY").isAfter(moment())
    ? moment(date, "DD-MM-YYYY").add(1, "d").format("DD-MM-YYYY")
    : moment().add(0, "d").format("DD-MM-YYYY");
};

export const getQuotationInceptionDate = (date) => {
  return moment(date, "DD-MM-YYYY").isAfter(moment())
    ? moment(date, "DD-MM-YYYY").format("DD-MM-YYYY")
    : moment().add(0, "d").format("DD-MM-YYYY");
};

export const prepareQuotationData = (quotationData) => {
  const {
    vehicleDetails,
    priceDetails,
    customerDetails,
    idNumber,
    productCode,
  } = quotationData;
  const { vehicleDetailsArray } = vehicleDetails;
  const { priceDetailsArray } = priceDetails;
  const { policyHolder } = customerDetails;
  // plateNumber: `${vehicleDetailsArray[0].plateNumber} ${vehicleDetailsArray[0].plateTextLeft} ${vehicleDetailsArray[0].plateTextMiddle} ${vehicleDetailsArray[0].plateTextRight}`,
  return {
    idNumber: idNumber,
    yearOfManufacture:
      quotationData.vehicleDetails.vehicleDetailsArray?.[0]?.vehicleValue
        ?.length > 0
        ? quotationData.vehicleDetails.vehicleDetailsArray?.[0]
            ?.yearOfManufacture
        : vehicleDetailsArray[0].yearOfManufacture,
    plateNumberCharchters: `${vehicleDetailsArray[0].plateTextLeft} **`,
    plateNumber: `${vehicleDetailsArray[0].plateNumber.slice(0, 1) + "***"}`,
    carTitle: `${vehicleDetailsArray[0].makeName} ${vehicleDetailsArray[0].modelMake} ${vehicleDetailsArray[0].yearOfManufacture}`,
    chassisNumber: vehicleDetailsArray[0].chassisNumber,
    seatingCapacity: vehicleDetailsArray[0].seatingCapacity,
    color: vehicleDetailsArray[0].colorName,
    transmissionName: vehicleDetailsArray[0].transmissionName,
    priceDetails: priceDetailsArray,
    premium: quotationData.premium,
    customerDetails: policyHolder[0],
    quotationStatus: quotationData.quotationStatus,
    driverDetails:
      quotationData.vehicleDetails.vehicleDetailsArray[0].vehicleDriverDetails
        .vehicleDriverDetailsArray,
    quotationNumber: quotationData.quotationNumber,
    vehicleDetails: quotationData.vehicleDetails.vehicleDetailsArray[0],
    productCode: productCode,
    vehicleValue: parseInt(
      quotationData.vehicleDetails.vehicleDetailsArray?.[0]?.vehicleValue
        ?.length > 0
        ? quotationData.vehicleDetails.vehicleDetailsArray?.[0]?.vehicleValue
        : { avg: vehicleDetailsArray?.[0]?.vehicleValue }
    ).toString(),
    deductible:
      quotationData.vehicleDetails.vehicleDetailsArray?.[0]
        ?.agencyRepairRequired?.length > 0
        ? quotationData.vehicleDetails.vehicleDetailsArray?.[0]?.deductible
        : vehicleDetailsArray[0].deductible,
    isPEP:
      quotationData.vehicleDetails.vehicleDetailsArray?.[0]
        ?.agencyRepairRequired?.length > 0
        ? quotationData.vehicleDetails.vehicleDetailsArray?.[0]
            ?.agencyRepairRequired
        : vehicleDetailsArray?.[0]?.agencyRepairRequired,
  };
};

export const getFursanMiles = (state) => {
  return state.proposal?.alfursanMileage || 0;
};

export const getChosenProposal = (state) => {
  if (!state.chosenProductCode) {
    return;
  }
  return state.motorProposals[state.chosenProductCode];
};

export const plateType = (state, translate) => {
  const vehicle = state.quotationInfo.vehicleDetails.vehicleDetailsArray[0];
  switch (vehicle.plateType) {
    case "1":
      return translate("motor-private-car");
    case "3":
      return translate("motor-private-transport");
    case "11":
      return translate("motor-temp-plate-no");
    default:
      return "";
  }
};

export const getProposalForSummary = (state, translate) => {
  if (!state.chosenProductCode) {
    return {};
  }
  let proposal = state.motorProposals[state.chosenProductCode];
  let shownPriceFactors = [];

  if (proposal && proposal.price) {
    let priceFactors = proposal.price;

    for (let priceCode of config.allowedPriceDetails) {
      let priceItem = priceFactors.find((item) => {
        return item.priceCode == priceCode;
      });
      if (
        priceItem &&
        priceItem.priceValue != "0" &&
        priceItem.priceValue != "0.0"
      ) {
        priceItem.priceValue = globalUtils.numberWithCommas(
          priceItem.priceValue
        );

        if (priceItem.priceCode.endsWith("P")) {
          priceItem.unit = "%";
        } else {
          priceItem.unit = translate("sar");
        }
        const vehicleDetails =
          state.quotationInfo.vehicleDetails.vehicleDetailsArray[0];
        if (priceItem.priceCode == "TOTC") {
          priceItem.priceName =
            vehicleDetails.makeName +
            " " +
            vehicleDetails.modelName +
            " " +
            vehicleDetails.yearOfManufacture;
          shownPriceFactors.push(priceItem);
          if (vehicleDetails.plateNo) {
            shownPriceFactors.push({
              priceName: translate("plate-no"),
              priceValue:
                vehicleDetails.plateTextRight +
                " " +
                vehicleDetails.plateTextMiddle +
                " " +
                vehicleDetails.plateTextLeft +
                " " +
                vehicleDetails.plateNumber,
            });
          }
          shownPriceFactors.push({
            priceName: translate("motor-plate-type"),
            priceValue: this.vuexStore.getters.plateType,
          });
          if (vehicleDetails.seatingCapacity) {
            shownPriceFactors.push({
              priceName: translate("seating-capacity"),
              priceValue: vehicleDetails.seatingCapacity,
            });
          }
          // if (!this.vuexStore.getters.isSanad) {
          //   shownPriceFactors.push({
          //     priceName: translate("deductible"),
          //     priceValue: utils.numberWithCommas(vehicleDetails.deductible),
          //   });
          //   shownPriceFactors.push({
          //     priceName: translate("vehicle-value"),
          //     priceValue: utils.numberWithCommas(
          //       vehicleDetails.vehicleValue
          //     ),
          //   });
          // }
        } else {
          priceItem.priceName = translate(
            config.priceTranslations[priceItem.priceCode]
          );
          shownPriceFactors.push(priceItem);
        }
      }
    }
  }
  return {
    priceFactors: shownPriceFactors,
    premium: proposal.premium
      ? globalUtils.numberWithCommas(proposal.premium)
      : "0",
  };
};

export const amount = (state) => {
  const proposal = state.motorProposals[state.chosenProductCode];

  if (!proposal) {
    return 0;
  }
  return proposal.premium ? config.numberWithCommas(proposal.premium) : "0";
};

export const buildProposalRequest = (
  quotationInfo,
  policyData,
  productCode
) => {
  const isRenewal =
    productCode !== "ALL" && productCode === policyData.productCode;

  let cleanedJson = JSON.parse(JSON.stringify(quotationInfo));
  try {
    cleanedJson.requestGeneratedTime = null;
    cleanedJson.upgradeDetails = {
      cancelDate: null,
      policyNumber: isRenewal ? policyData.quotationNumber : null,
    };

    delete cleanedJson.calculatedExpiryDate;
    delete cleanedJson.calculatedInceptionDate;
    delete cleanedJson.priceDetails;
    delete cleanedJson.policyTermsUrl;
    delete cleanedJson.premium;
    delete cleanedJson.resultCode;
    delete cleanedJson.resultMessage;

    delete cleanedJson.quotationExpiry;
    delete cleanedJson.quotationNumber;
    delete cleanedJson.quotationStatus;
    delete cleanedJson.responseGeneratedTime;
    delete cleanedJson.schemeCode;
    delete cleanedJson.channelDetails;

    if (
      cleanedJson.customerDetails &&
      cleanedJson.customerDetails.policyHolder
    ) {
      cleanedJson.customerDetails.policyHolder.forEach((policyHolder) => {
        let city = policyHolder.homeWaselCityCode;
        let region = policyHolder.homeWaselRegionCode;
        let gender = policyHolder.genderCode;
        //double hiphen issue

        Object.keys(policyHolder).forEach(function (key) {
          if (key.endsWith("Name") || key.endsWith("Code")) {
            delete policyHolder[key];
          }

          if (policyHolder[key] && policyHolder[key].includes("--")) {
            policyHolder[key] = policyHolder[key].replace("--", "-");
          }
        });

        delete policyHolder["driverType"];
        delete policyHolder["isPolicyHolder"];

        if (!policyHolder["fax"]) {
          policyHolder["fax"] = "";
        }
        if (!policyHolder["phoneOne"]) {
          policyHolder["phoneOne"] = "";
        }
        if (!policyHolder["phoneTwo"]) {
          policyHolder["phoneTwo"] = "";
        }

        policyHolder["officeAddressGeneral"] = null;
        policyHolder["officelatitude"] = null;
        policyHolder["officelongitude"] = null;
        policyHolder["officeSelfUnitNumber"] = null;

        policyHolder.homeWaselCityCode = city;

        policyHolder.homeWaselRegionCode = region;

        policyHolder.genderCode = gender;

        policyHolder.homeWaselRegionCode ||
          (policyHolder.homeWaselRegionCode = "1");
        policyHolder.homeWaselCityCode ||
          (policyHolder.homeWaselCityCode = "38");
      });
    }

    cleanedJson.vehicleDetails.vehicleDetailsArray.forEach((element) => {
      // element.plateTypeCode = element.plateTypeCode;

      element.majorDrivingRegionCode || (element.majorDrivingRegionCode = "1");
      element.majorDrivingCityCode || (element.majorDrivingCityCode = "38");

      delete element.absBreak;
      delete element.accessoryValue;
      delete element.adatCruise;
      delete element.antiBreak;
      delete element.antiTheft;
      delete element.axleWeight;
      delete element.camera360;
      delete element.carModifiedDescription;

      delete element.cruise;
      // delete element.customCardNumber;
      delete element.engineSizeCode;
      delete element.fireExtinguisher;
      delete element.frontCamera;
      delete element.isCarModified;
      delete element.parkFrontSensors;
      delete element.parkRearSensors;
      delete element.rearCamera;
      delete element.transferOwnerId;

      element["parkingLocationName"] = "";
      element["registrationExpiryDate"] = "11-12-2022";

      //setting min vehicle value if not available..
      if (
        !(
          element.vehicleValue ||
          element.vehicleValue == "" ||
          element.vehicleValue == 0
        )
      ) {
        element.vehicleValue = element.minValue;
      }
      element.vehicleValue = parseInt(element?.vehicleValue).toString();
      //production -1 issue
      Object.keys(element).forEach(function (key) {
        if (element[key] == "-1") {
          element[key] = null;
        }
      });
      delete element.colorName;
      delete element.makeName;
      //delete element.ncdYears;
      delete element.usageTypeName;
      delete element.priceDetails;
      delete element.modelMake;
      delete element.plateTypeName;
      delete element.plateType;
      delete element.insurancePeriod;
      delete element.minValue;
      delete element.maxValue;
      delete element.modelName;
      delete element.ncdValue;
      delete element.ncdYears;

      /*

            if (constants.TP == cleanedJson.productCode) {

                element.deductibleForUnifiedForm = null

                element.deductible = null

            } else {

                element.deductibleForUnifiedForm = element.deductible

            }

            */

      if (productCode == "ALL") {
        element.deductible = "3500";
        element.deductibleForUnifiedForm = "3500";
      }
      if (
        productCode == globalConfig.productCode.co &&
        productCode != "undefined"
      ) {
        element.deductibleForUnifiedForm =
          element.deductible && element.deductible !== "1250"
            ? element.deductible
            : "3500";
        element.deductible =
          element.deductible && element.deductible !== "1250"
            ? element.deductible
            : "3500";
      } else if (
        productCode == globalConfig.productCode.sp &&
        productCode != "undefined"
      ) {
        element.deductibleForUnifiedForm = "3500";
        element.deductible = element.deductibleSP ?? "1250";
        element.deductibleSP = element.deductible;
      } else if (
        productCode == globalConfig.productCode.tp &&
        productCode != "undefined"
      ) {
        element.deductibleForUnifiedForm = element.deductible;
        // element.deductibleForUnifiedForm = "500";
        element.deductible = null;
      }
      if (
        element.vehicleDriverDetails &&
        element.vehicleDriverDetails.vehicleDriverDetailsArray
      ) {
        //production -1 issue
        element.vehicleDriverDetails.vehicleDriverDetailsArray.forEach(
          (driver) => {
            //double hiphen issue
            Object.keys(driver).forEach(function (key) {
              if (key.endsWith("Name")) {
                delete driver[key];
              }
            });
            Object.keys(driver).forEach(function (key) {
              if (driver[key] == "-1") {
                driver[key] = null;
              }
            });

            driver["driverRelationCode"] = "NOR";
            driver["homeSelfUnitNumber"] = "";
            driver["officeSelfUnitNumber"] = "";
            driver.childUnderSixteenCode = driver.childUnderSixteenCode || "0";

            delete driver["alfursan_id"];
            delete driver["addressType"];
            delete driver["bankCode"];
            delete driver["cityCode"];
            delete driver["childUnderSixteen"];
            delete driver["email"];
            delete driver["fax"];
            delete driver["homelongitude"];
            delete driver["homeaddrlatitude"];
            delete driver["hijriBirthyear"];
            delete driver["iban"];
            delete driver["officelongitude"];
            delete driver["officelatitude"];
            delete driver["officeAddressGeneral"];
            delete driver["p_pep_employer"];
            delete driver["p_is_pep"];
            delete driver["p_pep_occupation"];
            delete driver["phoneOne"];
            delete driver["phoneTwo"];
            delete driver["p_aml_employer_details"];
            delete driver["preferredLanguageCode"];
            delete driver["p_pep_rank"];
            delete driver["p_pep_relevant_name"];
            delete driver["p_aml_birth_place"];
            delete driver["preferredContactMethodCode"];
            delete driver["p_aml_income_source"];
            delete driver["poBox"];
            delete driver["regionCode"];
            delete driver["zipCode"];
            delete driver["idNumber"];
            delete driver["yob"];
            delete driver["saudiDrivingLicenseExpCode"];
            delete driver["saudiDrivingLicenseExpName"];
            // delete driver["driverRelationCode"];
            delete driver["driverRelationName"];
            delete driver["otherCountriesLicenses"];
            delete driver["homelongitude"];
            delete driver["homelatitude"];
            delete driver["hijDob"];

            delete driver["driverNCD"];
            delete driver["licenseExpiryDate"];
            delete driver["licenseExperienceArray"];
            delete driver["licenseIssueDate"];
            delete driver["saudiLicenseNumber"];
            delete driver["resultCode"];
            delete driver["resultMessage"];
          }
        );

        var mainDriver =
          element.vehicleDriverDetails.vehicleDriverDetailsArray.find(
            (driver) => {
              return driver.driverType == "MD";
            }
          );
        element.majorDrivingRegionCode = mainDriver.homeWaselRegionCode;
        element.majorDrivingCityCode = mainDriver.homeWaselCityCode;
      }
      if (
        element.selectedFeatures &&
        element.selectedFeatures.selectedFeatures
      ) {
        element.selectedFeatures.selectedFeatures.forEach((feature) => {
          delete feature.featureText;
        });
      }
    });
    cleanedJson.demandRequestType = "";
    // cleanedJson.endorsementType = cleanedJson.endorsementCode;
    cleanedJson.endorsementType = isRenewal ? "RNW" : "PSL";
    delete cleanedJson.endorsementCode;
    cleanedJson.specialSchemeCode = "STANDARD";
    cleanedJson.productCode = productCode;
    // moment(cleanedJson.calculatedExpiryDate, 'YYYY-MM-DD').isAfter(moment())?
    // moment(cleanedJson.calculatedExpiryDate, 'YYYY-MM-DD').add(1,'d').format('DD-MM-YYYY') : moment().add(1,'d').format("DD-MM-YYYY")

    cleanedJson.requiredInceptionDate = getInceptionDate(
      cleanedJson.calculatedExpiryDate
    );
  } catch (err) {
    console.error(err);
  }

  cleanedJson.customerDetails.policyHolder[0].regionCode ||
    (cleanedJson.customerDetails.policyHolder[0].regionCode = "1");
  cleanedJson.customerDetails.policyHolder[0].cityCode ||
    (cleanedJson.customerDetails.policyHolder[0].cityCode = "38");
  cleanedJson.vehicleDetails.vehicleDetailsArray[0].majorDrivingRegionCode ||
    (cleanedJson.vehicleDetails.vehicleDetailsArray[0].majorDrivingRegionCode =
      "1");
  cleanedJson.vehicleDetails.vehicleDetailsArray[0].majorDrivingCityCode ||
    (cleanedJson.vehicleDetails.vehicleDetailsArray[0].majorDrivingCityCode =
      "38");

  return cleanedJson;
};

export const buildQuotationAPIRequest = (
  quotationInfo,
  policyData,
  productCode,
  driverRegistered
) => {
  const isRenewal = productCode === policyData.productCode;
  let cleanedJson = JSON.parse(JSON.stringify(quotationInfo));
  cleanedJson.productCode = productCode;

  delete cleanedJson.responseGeneratedTime;
  delete cleanedJson.priceDetails;
  delete cleanedJson.premium;
  delete cleanedJson.calculatedExpiryDate;
  delete cleanedJson.channelDetails;

  delete cleanedJson.quotationNumber

  if (isRenewal) {
    cleanedJson.endorsementPolicyNumber = policyData.policyNumber;
    cleanedJson.quotationNumber = policyData.quotationNumber
    // cleanedJson.consumerTrackingID = policyData.policyNumber;
    // cleanedJson.policyID= policyData.policyNumber;
    // cleanedJson.policyNum= policyData.policyNumber;
    // cleanedJson.genericCustomParameter =  null;
    // cleanedJson.genericDocuments = null;
    // cleanedJson.upgradeDetails =  {
    //   "cancelDate": null,
    //   "policyNumber": policyData.policyNumber
    // };
  }
  delete cleanedJson.resultCode;
  delete cleanedJson.resultMessage;

  cleanedJson.requiredInceptionDate = isRenewal
    ? cleanedJson.calculatedInceptionDate
    : getQuotationInceptionDate(cleanedJson.calculatedInceptionDate);
  delete cleanedJson.calculatedInceptionDate;

  cleanedJson.vehicleDetails.vehicleDetailsArray.forEach((element) => {
    // element.plateTypeCode = element.plateTypeCode;
    element.majorDrivingRegionCode =
      cleanedJson.customerDetails.policyHolder[0].regionCode;
    element.majorDrivingCityCode =
      cleanedJson.customerDetails.policyHolder[0].cityCode;
    delete element.colorName;
    delete element.minValue;
    delete element.plateType;
    delete element.maxValue;
    delete element.modelName;
    delete element.ncdValue;
    delete element.makeName;

    delete element.modelMake;
    delete element.plateTypeName;
    delete element.insurancePeriod;
    delete element.ncdYears;
    delete element.usageTypeName;
    delete element.priceDetails;

    if (
      element.vehicleDriverDetails &&
      element.vehicleDriverDetails.vehicleDriverDetailsArray
    ) {
      element.vehicleDriverDetails.vehicleDriverDetailsArray.forEach(
        (driver) => {
          driver.driverRelationCode = driver.driverRelationCode || "NOR";
          driver.childUnderSixteenCode = driver.childUnderSixteenCode || "0";
          delete driver.zipCode;
          delete driver.addressType;
          delete driver.preferredLanguageCode;
          delete driver.cityCode;
          delete driver.regionCode;
          delete driver.email;
          delete driver.preferredLanguageName;
          delete driver["p_pep_employer"];
          delete driver["p_is_pep"];
          delete driver["p_pep_occupation"];
          delete driver["phoneOne"];
          delete driver["phoneTwo"];
          delete driver["p_aml_employer_details"];
          delete driver["preferredLanguageCode"];
          delete driver["p_pep_rank"];
          delete driver["p_pep_relevant_name"];
          delete driver["p_aml_birth_place"];
          delete driver["preferredContactMethodCode"];
          delete driver["p_aml_income_source"];
          delete driver["poBox"];
          delete driver["childUnderSixteen"];
          delete driver["regionName"];
          delete driver["cityName"];
          delete driver["alfursan_id"];
          delete driver["yob"];
          delete driver["idNumber"];
          delete driver["otherCountriesLicenses"];
          delete driver["alfursan_id"];
          delete driver["hijriBirthyear"];
          delete driver["homelongitude"];
          delete driver["homelatitude"];
          delete driver["officeAddressGeneral"];
          delete driver["makeName"];
          delete driver["twitterName"];
          delete driver["bankCode"];
          delete driver["officelongitude"];
          delete driver["bankName"];
          delete driver["homeaddrlatitude"];
          delete driver["iban"];
          delete driver["officelatitude"];
          delete driver["fax"];
          delete driver["preferredContactMethodName"];
          delete driver["hijDob"];
          delete driver["resultCode"];
          delete driver["resultMessage"];
        }
      );
    }
    //deductible logic...

    if (productCode == globalConfig.productCode.tp) {
      element.deductibleForUnifiedForm = element.deductible;
      element.deductible = null;
    } else if (productCode == globalConfig.productCode.sp) {
      element.deductibleForUnifiedForm = "3500";
      element.deductible = element.deductibleSP ?? "1250";
      element.deductibleSP = element.deductible;
    } else {
      element.deductible =
        element.deductible && element.deductible !== "1250"
          ? element.deductible
          : "3500";
      element.deductibleForUnifiedForm = element.deductible || "3500";
    }
    if (element.selectedFeatures && element.selectedFeatures.selectedFeatures) {
      element.selectedFeatures.selectedFeatures.forEach((feature) => {
        delete feature.featureText;
      });
    }
    delete element.antiTheft;
    delete element.antiBreak;
    delete element.absBreak;
    delete element.cruise;
    delete element.adatCruise;
    delete element.rearCamera;
    delete element.frontCamera;
    delete element.camera360;
    delete element.axleWeight;
    delete element.parkRearSensors;
    delete element.parkFrontSensors;
    delete element.fireExtinguisher;
    delete element.deductibleSP;
  });

  if (cleanedJson.customerDetails && cleanedJson.customerDetails.policyHolder) {
    cleanedJson.customerDetails.policyHolder.forEach((policyHolder) => {
      delete policyHolder["claimsIn5YearsCode"];
      policyHolder.genderCode || (policyHolder.genderCode = "1");
      delete policyHolder.childUnderSixteenCode;
    });
  }

  cleanedJson.endorsementCode = isRenewal ? "RNW" : "NEW";
  cleanedJson.endorsementType = isRenewal ? "RNW" : "PSL";
  cleanedJson.specialSchemeCode = "STANDARD";
  cleanedJson.driveFlag =
    driverRegistered?.isDriverSelected &&
    (productCode === "PRMotorImtiazeSP" || productCode === "PRMotorImtiazeCO")
      ? "Y"
      : "N";

  return cleanedJson;
};
